import type React from "react";
import {useNavigate, useParams} from "react-router-dom";

import {faRankingStar} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";

import type {PlayLevelParams} from "../PlayLevelParams";

interface LeaderboardButtonProps {
  levelId?: string;
}

const LeaderboardButton: React.FC<LeaderboardButtonProps> = ({levelId}) => {
  const navigate = useNavigate();
  const {id, playlistId} = useParams<PlayLevelParams>();

  const handleClick = () => {
    const actualLevelId = levelId || id;
    if (playlistId && actualLevelId) {
      navigate(`/playlist/${playlistId}/play/${actualLevelId}/leaderboard`);
    }
  };

  return (
    <CustomButton
      onClick={handleClick}
      aria-label="Leaderboard"
      className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
    >
      <FontAwesomeIcon
        icon={faRankingStar}
        size="xl"
        className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-purple-600 via-purple-500 to-black"
      />
    </CustomButton>
  );
};

export default LeaderboardButton;
